





























import Vue from "vue";
import Component from "vue-class-component";
import { LoadingSpinnerService, UserStore } from "@/store";
import ApiFactory from "@/api/ApiFactory";
import {
  ClientListRowDto,
  BrokerDetailsDto,
  ContactProfileDto
} from "@/api/ClientPortalApiClient";
import { BFormInput, BInputGroup, BTable, BvTableField } from "bootstrap-vue";
import { FormatDate } from "@/filters/FormatDate";
import router, { ROUTES } from "@/router";
import AdvisorClientView from "@/views/broker/AdvisorClientView.vue";

@Component({
  components: {
    AdvisorClientView
  }
})
export default class AdvisorHome extends Vue {
  public broker: BrokerDetailsDto | null = null;
  public clients: ContactProfileDto[] = [];
  public items: any[] = [];
  public fields = [
    {
      key: "id",
      tdClass: ["d-none", "d-md-block"],
      thClass: ["d-none", "d-md-block"]
    },
    {
      key: "fullName",
      sortable: true
    },
    {
      key: "dateOfBirth",
      sortable: false,
      formatter: this.formatDob,
      filterByFormatted: true
    },
    {
      key: "status",
      sortable: true
    },
    {
      key: "spouseOrPartnerName",
      sortable: true
    },
    {
      key: "spouseOrPartnerDOB",
      sortable: false,
      formatter: this.formatDob,
      filterByFormatted: true
    },
    {
      key: "mobile",
      sortable: true
    },
    {
      key: "phone",
      sortable: true
    },
    {
      key: "fileRef",
      sortable: true
    }
  ];
  public filterString: string = "";

  created() {
    document.addEventListener("keydown", this.handleKeyPress);
  }

  beforeUnmount() {
    document.removeEventListener("keydown", this.handleKeyPress);
  }

  handleKeyPress(event: any) {
    if (event.key === "Enter" && this.filterString !== "") {
      this.Search();
    }
  }

  async Search() {
    this.filterString = this.filterString.trim();

    if (this.filterString == "") {
      LoadingSpinnerService.Failure("Search cannot be empty.");
      return;
    }

    setTimeout(async () => {
      LoadingSpinnerService.Show("Loading clients...");
      try {
        this.items = [];
        await this.GetByName(this.filterString);
        if (this.items.length > 0) {
          LoadingSpinnerService.Hide();
        }
      } catch (e) {
        LoadingSpinnerService.Failure(
          "Unable to load clients. Please try again."
        );
      }
    }, 100);
  }

  private async PopulateItems() {
    this.clients.forEach(client => {
      let formattedClient = {
        id: client.id,
        status: client.contactStatusName,
        fullName: `${client.firstName} ${client.lastName}`,
        dateOfBirth: client.dateOfBirth,
        phone: client.phoneNo,
        mobile: client.mobileNo,
        spouseOrPartnerName: `${client.sP_FirstName} ${client.sP_LastName}`,
        spouseOrPartnerDOB: client.sP_DateOfBirth,
        fileRef: client.fileRef
      };

      this.items.push(formattedClient);
    });
  }

  private async GetByName(name: string) {
    const api = ApiFactory.CreateDataClient();
    this.clients = await api.profile_getByName(name);
    if (this.clients.length == 0) {
      LoadingSpinnerService.Failure("No clients found.");
    }
    await this.PopulateItems();
  }

  private async GetClients() {
    const api = ApiFactory.CreateDataClient();
    this.clients = await api.profile_getByContactOwnerId(UserStore.profileId);
  }

  get brokerName(): string | undefined {
    return this.broker !== null ? this.broker.name : "";
  }

  get brokerAgency(): string | undefined {
    return this.broker !== null ? this.broker.agencyCode : "";
  }

  private formatDob(
    value: object,
    key: string,
    item: ClientListRowDto
  ): string {
    if (value === null || value === undefined) {
      return "";
    }
    return FormatDate.format(value.toString());
  }

  public onRowSelected(items: ClientListRowDto[]) {
    document.removeEventListener("keydown", this.handleKeyPress);
    const selected = items[0];
    router.push({
      name: ROUTES.advisorClientView,
      params: { contactId: selected.id.toString() }
    });
  }
}
